module.exports = __webpack_public_path__ + "img/verygood.7831f9d5.svg";